import React, { LegacyRef } from 'react';
import { css } from 'linaria';
import { SectionSubTitle, SignSection } from 'common/components';
import { KITCHEN_ELEMENT_BLOCK, KITCHEN_SIGN_UP_HREF } from '../../../kitchen-constants';
import { NewKitchenSignSectionPanel } from './components';
import { NEW_KITCHEN_SIGN_SECTION_GALLERY_LIST } from './new-kitchen-sign-section-constants';

export const newKitchenSignSection = css`
  @media (--from-desktop) {
    padding-bottom: 40px;
  }
`;

const newKitchenSignSectionTitle = css`
  && {
    width: 456px;
    margin-bottom: 8px;

    @media (--to-desktop) {
      width: 414px;
    }

    @media (--only-mobile) {
      width: 100%;
    }
  }
`;

type NewKitchenSignSectionProps = {
  panelRef: LegacyRef<HTMLDivElement>;
  regionId: string;
};

export const NewKitchenSignSection: React.FC<NewKitchenSignSectionProps> = ({ panelRef, regionId }) => (
  <SignSection
    className={newKitchenSignSection}
    elementBlock={KITCHEN_ELEMENT_BLOCK}
    elementName="Приезжайте в гости — посмотрите кухни вживую"
    galleryList={NEW_KITCHEN_SIGN_SECTION_GALLERY_LIST}
    signHref={KITCHEN_SIGN_UP_HREF}
    renderTitle={() => (
      <SectionSubTitle className={newKitchenSignSectionTitle} margin="s" color="text-invert">
        Приезжайте в&nbsp;гости&nbsp;&mdash; посмотрите кухни вживую
      </SectionSubTitle>
    )}
    renderAddContent={() => (
      <NewKitchenSignSectionPanel panelRef={panelRef} regionId={regionId} />
    )}
  />
);
